import * as Api from '@ViewModels';
import { ImageLibraryManager } from '../../../../../web/components-v2/ImageLibraryManager';

/**
 * The account's image library, from the inside. Lets CSMs and the content team load images into an account
 * ahead of building content for it, read the reference files the client has left, and clean up what is
 * already there.
 */
export function ImageLibraryTab({ impersonationContext }: { impersonationContext: Api.IImpersonationContext }) {
	return (
		<ImageLibraryManager
			allowFiles
			description="Images and reference files in this account's library, available to everyone on the account and usable anywhere they add images in Levitate. Removing something takes it out of the library only: content already using it keeps working."
			emptyDescription={
				'Add images here, or they will show up when someone on the account chooses "Save to my images" while creating content.'
			}
			emptyTitle='This account has no images yet'
			heading='Image Library'
			impersonationContext={impersonationContext}
		/>
	);
}
